@if (type !== 'number') {
  <input
    class="text-90 is-family-regular"
    [type]="type"
    [placeholder]="placeholder()"
    required
    [id]="unique"
    [formControl]="inputText"
    [autocomplete]="autocomplete()"
    (focus)="onFocus()"
    (blur)="onBlur()">
}

@if (type === 'number') {
  <input
    [ngClass]="styleClass()"
    class="text-90 is-family-regular"
    type="number"
    [placeholder]="placeholder()"
    required
    [id]="unique"
    [formControl]="inputText"
    (focus)="onFocus()"
    (blur)="onBlur()">
}

<label [for]="unique" (mousedown)="clickOnIcon()">
  @if (hasEdit()) {
    <app-icon
      name="edit"
    class="icon text-24 text-grey-30 edit"></app-icon>
  }
  <app-icon #clearIcon
    name="clear"
  class="icon text-24 text-grey-30 is-cursor-pointer clear"></app-icon>
</label>
